declare global {
  interface Window {
    __ENV__?: {
      VITE_ROUTE_API_BASE_URL?: string;
      VITE_ROUTE_BASE_URL?: string;
      VITE_SENTRY_DSN?: string;
      VITE_MATOMO_URL?: string;
      VITE_MATOMO_SITE_ID?: string;
      VITE_MATOMO_DIMENSION_USER?: string;
      VITE_MATOMO_DIMENSION_ROLE?: string;
      VITE_LISTMONK_URL?: string;
      VITE_COMPLIANCE_URL?: string;
      VITE_PULSE_URL?: string;
      VITE_KEYCLOAK_URL?: string;
      VITE_KEYCLOAK_REALM?: string;
      VITE_KEYCLOAK_CLIENT_ID?: string;
    };
  }
}

const runtime = typeof window !== 'undefined' ? (window.__ENV__ ?? {}) : {};

export const env = {
  VITE_ROUTE_API_BASE_URL:
    runtime.VITE_ROUTE_API_BASE_URL ?? import.meta.env.VITE_ROUTE_API_BASE_URL,
  VITE_ROUTE_BASE_URL:
    runtime.VITE_ROUTE_BASE_URL ?? import.meta.env.VITE_ROUTE_BASE_URL,
  VITE_SENTRY_DSN: runtime.VITE_SENTRY_DSN ?? import.meta.env.VITE_SENTRY_DSN,
  VITE_MATOMO_URL: runtime.VITE_MATOMO_URL ?? import.meta.env.VITE_MATOMO_URL,
  VITE_MATOMO_SITE_ID:
    runtime.VITE_MATOMO_SITE_ID ?? import.meta.env.VITE_MATOMO_SITE_ID,
  VITE_MATOMO_DIMENSION_USER:
    runtime.VITE_MATOMO_DIMENSION_USER ??
    import.meta.env.VITE_MATOMO_DIMENSION_USER,
  VITE_MATOMO_DIMENSION_ROLE:
    runtime.VITE_MATOMO_DIMENSION_ROLE ??
    import.meta.env.VITE_MATOMO_DIMENSION_ROLE,
  // Deep-link to the Listmonk campaign editor (VPN-only host, per environment).
  // Unset in envs without Listmonk — the page hides the "Open Listmonk" button.
  VITE_LISTMONK_URL:
    runtime.VITE_LISTMONK_URL ?? import.meta.env.VITE_LISTMONK_URL,
  // Base URL of the compliance service, per environment. Client data is edited there now — the
  // company card and the Onboarding tab link out to it, and compliance forwards its writes to
  // master-data-service. Unset in an environment that has no compliance, and those links are not
  // rendered at all (see @utils/complianceLinks).
  VITE_COMPLIANCE_URL:
    runtime.VITE_COMPLIANCE_URL ?? import.meta.env.VITE_COMPLIANCE_URL,
  // Pulse, the app that has taken over from Chats & Tasks. It is a separate portal behind the same
  // realm, so the sidebar only links out to it. Unset in an environment that has no Pulse, and the
  // item is not rendered at all (see @entities/Sidebar/menu) — which, now that the legacy Chats &
  // Tasks item is gone, means a sidebar with no chat entry rather than a fallback to the old page.
  VITE_PULSE_URL: runtime.VITE_PULSE_URL ?? import.meta.env.VITE_PULSE_URL,
  // Keycloak SSO. All three must be set for the app to authenticate against the realm; with any of
  // them empty the auth module never initialises and the app stays on the legacy token path,
  // which is what keeps the mock-server e2e specs runnable (see @auth).
  VITE_KEYCLOAK_URL:
    runtime.VITE_KEYCLOAK_URL ?? import.meta.env.VITE_KEYCLOAK_URL,
  VITE_KEYCLOAK_REALM:
    runtime.VITE_KEYCLOAK_REALM ?? import.meta.env.VITE_KEYCLOAK_REALM,
  VITE_KEYCLOAK_CLIENT_ID:
    runtime.VITE_KEYCLOAK_CLIENT_ID ?? import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
} as const;
